import { Col } from "react-bootstrap";
import PersonReviewedIndicator from "./PersonReviewedIndicator";
import "./PersonReviewedIndicatorsList.css";

function PersonReviewedIndicatorsList({ indicators }) {
  return (
    <Col>
      {indicators.map((element) => (
        <PersonReviewedIndicator
          key={element._id}
          id={element._id}
          description={element.description}
          grade={element.indicatorTotalAverage}
          weight={element.weight}
        />
      ))}
    </Col>
  );
}

export default PersonReviewedIndicatorsList;
